/**
 * *(AI-generated)*
 * Returns the stored upsell success redirect path if applicable, otherwise returns undefined.
 */
export const redirectAfterUpsell = (): string | undefined => {
  const upsellRedirect = window.sessionStorage?.getItem('upsellSuccessRedirect')

  if (
    upsellRedirect &&
    upsellRedirect !== window.location.pathname &&
    document.referrer?.indexOf('success') > -1
  ) {
    return upsellRedirect
  }
}

/**
 * *(AI-generated)*
 * Removes the upsell redirect and route markup entries from session storage.
 */
export const removeUpsellRoute = (): void => {
  const upsellRedirect = window.sessionStorage?.getItem('upsellSuccessRedirect')
  const upsellRouteMarkup = window.sessionStorage?.getItem('upsellRouteMarkup')

  if (upsellRedirect) {
    window.sessionStorage.removeItem('upsellSuccessRedirect')
  }

  if (upsellRouteMarkup) {
    window.sessionStorage.removeItem('upsellRouteMarkup')
  }
}
